<!-- 只做移动端-横屏适配，pc端直接展示移动端页面 -->
<template>
  <div class="mobile mwr2025-home bg" :class="locale">
    <ActLang />
    <div class="book">
      <div class="stats-page">
        <div class="intro-text" :class="locale">
          <div class="text-item" v-for="(text, index) in $t('mwr.home.statsPage.text').split('\n')" :key="index">{{ text }}</div>
        </div>
        <div class="btn" @click="goStats">
          {{ $t('mwr.home.statsPage.btnText') }}
        </div>
      </div>
      <div class="dragon-page">
        <div class="intro-text" :class="locale">
          <div class="text-item" v-for="(text, index) in $t('mwr.home.dragonPage.text').split('\n')" :key="index">{{ text }}</div>
        </div>
        <div class="btn" @click="goDragon">
          {{ $t('mwr.home.dragonPage.btnText') }}
        </div>
      </div>
    </div>
    <!-- mwr2025-home
    <button @click="showValidateUserDialog">show validate user dialog</button>
    <button @click="goStats">go stats</button>
    <button @click="goDragon">go dragon</button>
     -->
    <ActTimeDialog></ActTimeDialog>
  </div>
</template>

<script setup>
/* eslint-disable */
import { isMobile } from '@/utils'
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import UserInfo from '../components/UserInfo/index.vue'
import RotatePhone from '@/components/RotatePhone/index.vue'
import ActLang from '../components/ActLang/index.vue'
import { useI18n } from 'vue-i18n'
import ActTimeDialog from '../components/Dialog/ActTimeDialog/index.vue'
const router = useRouter()
const cssType = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
const state = reactive({
})
const goStats = () => {
  router.push({ name: 'MWR2025Stats' })
}
const goDragon = () => {
  router.push({ name: 'MWR2025Dragon' })
}
</script>

<style scoped lang="less" src="./mobile_style.less"></style>
